module.exports = __webpack_public_path__ + "img/phone-solid.a658219e.svg";